// extracted by mini-css-extract-plugin
export default {"footer-bottom":"Footer_footer-bottom__3GO2G","links":"Footer_links__3673g"};